// Tags to identify the MTB1 flow and blueprint
export const TAG_MTB1_BLUEPRINT = '669ae792-1e43-4484-a911-a51181c11386';
export const TAG_MTB1_FLOW = '5f4a6fd1-c86f-41fa-a7ad-024b05b76f2c';

const flowName = 'Accelerated Agreements for Prospects';

export const getProspectAgreementFlowDsl = (blueprintId: string) => {
	return `flow:\n  name: ${flowName}\n  description: Convert a prospect to a client\n  active: true\n  tags:\n    \'${TAG_MTB1_FLOW}\': true\n  spec:\n    blueprintRef: ${blueprintId}\n    params: []\n`;
};
